module.exports = __webpack_public_path__ + "static/media/home-featured.994df550.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-featured.svg
// module id = 159
// module chunks = 0